export enum OnboardingResponseCodes {
    SUCCESS_OPERATION = 40000,
    INTERNAL_SERVER_ERROR = 49999,
}
